<template>
  <div>
    <template v-if="readOnly">
      {{ text }}
    </template>
    <template v-else>
      <v-select
        v-bind="$attrs"
        v-on="$listeners"
        :placeholder="config.PLACEHOLDER_SP"
        dense
        class="mt-2"
        :disabled="facilityStatus.read_only_row"
      >
        <slot />
      </v-select>
    </template>
  </div>
</template>

<script>
import config from "@/js/const";
export default {
  name: "EvaFacilityStatusListSelect",
  inheritAttrs: false,
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    text: {
      type: String
    },
    facilityStatus: {
      type: Object,
      default: undefined
    }
  },
  data: () => ({
    config: config
  })
};
</script>
